import {defineNuxtRouteMiddleware, navigateTo} from '#app';
import {useAuth} from '#imports';
import {useLegalEntityEditionRights} from '~/composables/organization-settings/useLegalEntityEditionRights';

export default defineNuxtRouteMiddleware((to) => {
    const {getSelectedIdentity} = useAuth();
    const {hasLegalEntityEditionRights} = useLegalEntityEditionRights();

    const organizationId = (to.params.id as string) || getSelectedIdentity?.organizationId;

    if (!organizationId || !hasLegalEntityEditionRights(organizationId)) {
        return navigateTo('/', {external: true});
    }
});
